<template>
  <div class="online-container">
    <img
      :src="
        !!exhibitor.properties && !!exhibitor.properties.backgroundImage
          ? exhibitor.properties.backgroundImage
          : require('../assets/images/slide1.png')
      "
      style="width: 100%; height: auto"
    />
    <div class="container">
      <div class="online-header row" style="padding: 30px 0">
        <div class="bread">
          <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item :to="{ path: '/' }">{{
              $t("ChinaCycle")
            }}</el-breadcrumb-item>
            <el-breadcrumb-item :to="{ path: '/business' }">{{
              $t("business")
            }}</el-breadcrumb-item>
            <el-breadcrumb-item
              v-if="exhibitor.venue"
              :to="{ path: `/business?venue.id=${exhibitor.venue.id}` }"
              >{{
                $i18n.locale == "zh"
                  ? exhibitor.venue.number + "馆"
                  : exhibitor.venue.number
              }}</el-breadcrumb-item
            >
            <el-breadcrumb-item
              :to="{ path: `/companyIntroduction?id=${exhibitor.id}` }"
            >
              <!-- <div class="text-ellipsis" style="max-width: 800px;"> -->
              {{ $i18n.locale == "zh" ? exhibitor.name : exhibitor.nameEn }}
              <!-- </div> -->
            </el-breadcrumb-item>
            <el-breadcrumb-item>{{ $t("Products List") }}</el-breadcrumb-item>
          </el-breadcrumb>
        </div>
      </div>
      <div class="company-box row-between">
        <div class="company-img">
          <img
            :src="
              !!exhibitor.properties && !!exhibitor.properties.logo
                ? exhibitor.properties.logo
                : require('../assets/images/icon_2.png')
            "
            style="max-width: 100%; max-height: 100%; cursor: pointer"
            @click="handleExhibitorClick(exhibitor)"
          />
        </div>
        <div class="company-detail-box">
          <div class="row-between company-detail">
            <p
              class="company-name"
              style="cursor: pointer"
              @click="handleExhibitorClick(exhibitor)"
            >
              {{ $i18n.locale == "zh" ? exhibitor.name : exhibitor.nameEn }}
            </p>
            <div class="row company-option">
              <div
                v-if="exhibitor.collected"
                style="display: flex; cursor: pointer"
                @click.stop="
                  handleCollectClick('EXHIBITOR', exhibitor.id, true)
                "
              >
                <img
                  src="../assets/images/icon_fover.png"
                  style="width: 14px; height: 12px"
                />
                <p>
                  {{ $t("Favorite") }}
                </p>
              </div>
              <div
                v-else
                style="display: flex; cursor: pointer"
                @click.stop="
                  handleCollectClick('EXHIBITOR', exhibitor.id, false)
                "
              >
                <img
                  src="../assets/images/icon_save.png"
                  style="width: 14px; height: 12px"
                />
                <p style="color: #999999">
                  {{ $t("Favorite") }}
                </p>
              </div>

              <div class="line"></div>
              <div
                v-if="exhibitor.liked"
                style="display: flex; cursor: pointer"
                @click.stop="handleLikeClick('EXHIBITOR', exhibitor.id, true)"
              >
                <img
                  src="../assets/images/icon_star.png"
                  style="width: 13px; height: 14px"
                />
                <p>{{ $t("Like") }}</p>
              </div>
              <div
                v-else
                style="display: flex; cursor: pointer"
                @click.stop="handleLikeClick('EXHIBITOR', exhibitor.id, false)"
              >
                <img
                  src="../assets/images/icon_unstar.png"
                  style="width: 13px; height: 14px"
                />
                <p style="color: #999999">{{ $t("Like") }}</p>
                <!-- <p style="color: #999999">{{ $t("Liked") }}</p> -->
              </div>
            </div>
          </div>
          <div class="row-between" style="flex: 1">
            <div class="company-detail-desc">
              <p style="display: flex; align-items: center;">
                <span style="margin-right: 5px; display: inline-block;">{{
                  $t("Business Content")
                }}</span>
                <span
                  class="text-ellipsis"
                  style="display: inline-block; width: 350px;"
                  >{{
                    $i18n.locale == "zh"
                      ? exhibitor.businessScope
                      : exhibitor.businessScopeEn
                  }}</span
                >
              </p>
              <p style="display: flex; align-items: center;">
                <span style="margin-right: 5px; display: inline-block;">{{
                  $t("Company Address")
                }}</span>
                <span
                  class="text-ellipsis"
                  style="display: inline-block; width: 350px;"
                  >{{
                    $i18n.locale == "zh"
                      ? exhibitor.address
                      : exhibitor.addressEn
                  }}</span
                >
              </p>
            </div>
            <div class="row company-btnlist">
              <p @click.stop="handleAppointmentClick(exhibitor)">
                {{ $t("Reservation") }}
              </p>
              <p v-if="false" @click.stop="handleContactClick(exhibitor)">
                {{ $t("contact") }}
              </p>
            </div>
          </div>
        </div>
      </div>
      <div class="row-between" style="padding: 30px 0">
        <div class="row">
          <div class="row online-sort">
            <el-radio-group
              fill="#619A37"
              text-color=""
              style="margin-right: 20px"
              size="mini"
              v-model="sorter.field"
              @change="handleParamChange"
            >
              <el-radio-button
                v-for="sort in sorters"
                :label="sort.value"
                :key="sort.value"
                >{{ sort.lable }}</el-radio-button
              >
            </el-radio-group>
          </div>
        </div>
        <p class="checkall">
          {{ $t("Product ... in total", { total: pagination.total }) }}
        </p>
      </div>
      <div>
        <div class="online-list">
          <div
            v-for="(item, idx) in entities"
            :key="idx"
            class="online-item column-between"
            @click="handleExhibitClick(item)"
          >
            <div class="online-item-top">
              <div class="online-item-img">
                <img
                  class="online-icon-recom"
                  :src="
                    item.properties.albums[0] ||
                      require('../assets/images/bike.png')
                  "
                />
              </div>
              <p
                class="online-item-name text-ellipsis"
                style="max-width: 270px;"
              >
                {{ $i18n.locale == "zh" ? item.name : item.nameEn }}
              </p>
            </div>
            <p class="online-item-comp">
              <!--{{-->
              <!--  item.categories-->
              <!--    .map((c) =>-->
              <!--      $i18n.locale == "zh" ? c.category.name : c.category.nameEn-->
              <!--    )-->
              <!--    .join(" | ")-->
              <!--}}-->
              {{
                $i18n.locale == "zh" ? item.categoryName : item.categoryNameEn
              }}
            </p>
          </div>
        </div>
        <el-pagination
          style="text-align: center; padding-bottom: 30px"
          background
          layout="prev, pager, next"
          :current-page="pagination.current"
          :page-size.sync="pagination.pageSize"
          :total="pagination.total"
          @current-change="handlePageChange"
        >
        </el-pagination>
      </div>
    </div>
    <Dialoglist
      :exhibitid="exhibitid"
      :dialogtype="'contactbusiness'"
      :dialogFormVisible="dialogFormVisible"
      @handleCloseDialog="is => (dialogFormVisible = is)"
    />
    <Dialoglist
      :exhibitid="exhibitid"
      :dialogtype="'reserve'"
      :dialogFormVisible="reservedialogFormVisible"
      @handleCloseDialog="is => (reservedialogFormVisible = is)"
    />
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

import { EventBus } from "../EventBus";

import ExhibitorService from "../services/exhibitor";
import ExhibitService from "../services/exhibit";

import Dialoglist from "@/components/dialoglist";
import { getExhibitsPageList } from "../http/api";
import { getExhibitsByPage } from "../services/exhibit";

export default {
  components: { Dialoglist },
  data() {
    return {
      dialogFormVisible: false,
      reservedialogFormVisible: false,
      exhibitor: {},
      // 排序
      sorters: [
        {
          lable: this.$t("Default"),
          value: "order_number desc"
        },
        {
          lable: this.$t("Latest"),
          value: "create_time desc"
        }
      ],
      // 数据服务
      service: ExhibitService,
      // 初始参数绑定
      entity: {
        enabled: true
        // approved: true,
        // approveResult: "APPROVED",
      },
      // 查询参数绑定
      filters: {},
      // 查询排序参数绑定
      sorter: {
        field: "order_number desc",
        order: "DESC"
      },
      // 页面数据
      entities: [],
      // 分页参数
      pagination: {
        current: 1,
        pageSize: 12,
        showQuickJumper: true,
        showSizeChanger: true,
        total: 0
      }
    };
  },
  computed: {
    ...mapGetters({
      hasAuthentication: "hasAuthentication",
      hasCollected: "hasCollected",
      hasLiked: "hasLiked"
    })
  },
  methods: {
    ...mapActions({
      addCollected: "addCollected",
      deleteCollected: "deleteCollected",
      addLiked: "addLiked",
      deleteLiked: "deleteLiked"
    }),
    handleCheckedCitiesChange(value) {},
    handleExhibitorClick(exhibitor) {
      this.$router.push({ path: `/companyIntroduction?id=${exhibitor.id}` });
    },
    handleExhibitClick(exhibit) {
      this.$router.push(`/exhibit/${exhibit.id}?from=exhibitor`);
    },
    // -------------------------------------------------------------------------------------------------
    // 联系点击事件
    handleContactClick(exhibit) {
      if (!this.hasAuthentication()) {
        this.$router.push("/login");
        return;
      }

      this.exhibitid = exhibit.id;
      this.dialogFormVisible = true;
    },
    // 预约点击事件
    handleAppointmentClick(exhibit) {
      if (!this.hasAuthentication()) {
        this.$router.push("/login");
        return;
      }

      this.exhibitid = exhibit.id;
      this.reservedialogFormVisible = true;
    },
    async handleCollectClick(type, id, status) {
      if (status) {
        // 已经收藏
        await this.deleteCollected({
          type: type,
          id: id
        });
      } else {
        //收藏
        await this.addCollected({
          type: type,
          id: id
        });
      }
    },
    async handleLikeClick(type, id, status) {
      if (status) {
        // 已经收藏
        await this.deleteLiked({
          type: type,
          id: id
        });
      } else {
        //收藏
        await this.addLiked({
          type: type,
          id: id
        });
      }
    },
    handleParamChange() {
      this.pagination.current = 1;
      this.getEntityPage(
        this.entity,
        this.pagination,
        this.filters,
        this.sorter
      );
    },
    handlePageChange(page) {
      this.pagination.current = page;
      this.getEntityPage(
        this.entity,
        this.pagination,
        this.filters,
        this.sorter
      );
    },
    async getExhibitor(exhibitor) {
      const result = await ExhibitorService.getEntity(exhibitor);

      this.exhibitor = result;

      this.exhibitor.liked = this.hasLiked("EXHIBITOR", this.exhibitor.id);
      this.exhibitor.collected = this.hasCollected(
        "EXHIBITOR",
        this.exhibitor.id
      );
    },
    async getEntityPage(entity, pagination, filters, sorter) {
      if (filters) {
        for (const key in filters) {
          const param = filters[key];
          entity[key] = param;
        }
      }

      const pageable = {
        page: pagination.current - 1,
        size: pagination.pageSize,
        sort: sorter.field,
        isUp: true
      };

      // const result = await getExhibitsPageList(entity, pageable);
      const result = await getExhibitsByPage({
        ...entity,
        ...pageable
      });
      this.entities = result.content;
      this.pagination.current = result.number + 1;
      this.pagination.total = result.totalElements;
      this.entities.forEach(exhibit => {
        exhibit.liked = this.hasLiked(exhibit.id);
        exhibit.collected = this.hasCollected(exhibit.id);
      });
    }
  },
  async mounted() {
    this.entity.exhibitorId = this.$route.query.id;

    this.getExhibitor({ id: this.entity.exhibitorId });

    this.getEntityPage(this.entity, this.pagination, this.filters, this.sorter);

    EventBus.$on("setLiked", () => {
      this.exhibitor = {
        ...this.exhibitor,
        liked: this.hasLiked("EXHIBITOR", this.exhibitor.id)
      };
    });

    EventBus.$on("setCollected", () => {
      this.exhibitor = {
        ...this.exhibitor,
        collected: this.hasCollected("EXHIBITOR", this.exhibitor.id)
      };
    });
  }
};
</script>
<style lang="less" scoped>
.online-container {
  background: #eaeaea;
  .container {
    width: 1200px;
    margin: 0 auto;
  }
}

.online-list {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  // justify-content: space-between;
}
.online-item:hover .online-item-comp {
  background: #619a37;
  color: #ffffff;
}
.online-item:nth-child(4n) {
  margin-right: unset;
}
.online-item {
  width: 277px;
  height: 372px;
  background: #fff;
  margin-bottom: 30px;
  cursor: pointer;
  margin-right: 30px;
  .online-item-top {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    height: 100%;
    align-items: center;
    .online-item-img {
      width: 278px;
      height: 272px;
      display: flex;
      align-items: center;
      justify-content: center;
      .online-icon-recom {
        max-width: 100%;
        max-height: 100%;
      }
    }
    .online-item-name {
      font-size: 14px;
      font-family: FZLanTingHeiS-DB1-GBK;
      font-weight: 400;
      color: #444444;
      text-align: center;
      padding: 18px 0;
      width: 80%;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }
  }
  .online-item-comp {
    font-size: 14px;
    font-family: FZLanTingHeiS-DB1-GBK;
    font-weight: 400;
    color: #999999;
    height: 46px;
    width: 100%;
    text-align: center;
    line-height: 46px;
    border-top: 1px solid #dddddd;
  }
}
.online-sort-title {
  font-size: 14px;
  font-family: FZLanTingHeiS-DB1-GBK;
  font-weight: 400;
  color: #444444;
}
.online-header-list {
  display: flex;
  flex-direction: row;
  width: 628px;
  height: 399px;
  margin-top: 40px;
  flex-wrap: wrap;
  .online-header-item {
    width: 157px;
    height: 133px;
    display: flex;
    flex-direction: column;
    align-items: center;
    background: #333333;
    cursor: pointer;
    .online-header-img {
      width: 157px;
      height: 100px;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      img {
        height: 56px;
      }
    }
    .online-header-text {
      font-size: 14px;
      font-family: FZLanTingHeiS-DB1-GBK;
      font-weight: 400;
      color: #ffffff;
    }
  }
}
.online-header-item:hover {
  background: #619a37;
}
/deep/ .online-swiper .el-carousel__container {
  height: 399px !important;
  width: 572px;
}
.online-header-swiper {
  margin-top: 40px;
  background: #ffffff;
}
.online-siper-detail {
  padding: 100px 15px 30px 15px;
  height: 100%;
  box-sizing: border-box;
  .online-siper-name {
    font-size: 14px;
    font-family: FZLanTingHeiS-DB1-GBK;
    font-weight: 400;
    color: #444444;
  }
  .online-siper-comp {
    font-size: 14px;
    font-family: FZLanTingHeiS-DB1-GBK;
    font-weight: 400;
    color: #999999;
    margin-top: 16px;
    margin-bottom: 14px;
  }
  .online-siper-btnlist {
    p {
      width: 58px;
      height: 30px;
      background: #619a37;
      border-radius: 2px;
      line-height: 30px;
      text-align: center;
      font-size: 12px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #ffffff;
      margin-right: 4px;
    }
  }
  .online-swiper-line {
    width: 100px;
    height: 1px;
    background: #999999;
    margin: 20px 0;
  }
  .online-siper-desc {
    font-size: 12px;
    font-family: FZLanTingHeiS-DB1-GBK;
    font-weight: 400;
    color: #666666;
  }
}
.online-header-left {
  height: 100%;
  .online-header-tag {
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    justify-content: space-between;
    .online-icon-recom {
      width: 101px;
      height: 101px;
    }
    .online-icon-new {
      width: 50px;
      height: 38px;
      margin-top: 20px;
    }
  }
  .online-swiper-img {
    margin: -8px 0 0 10px;
  }
}
.checkall {
  font-size: 14px;
  font-family: FZLanTingHeiS-DB1-GBK;
  font-weight: 400;
  color: #999999;
}
.company-img {
  width: 187px;
  height: 133px;
  background: #ffffff;
  border: 1px solid #dddddd;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  margin-right: 30px;
  flex-shrink: 0;
}

.company-box {
  background: #ffffff;
  padding: 30px;
}
.company-detail-box {
  height: 133px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  flex: 1;
  overflow: hidden;
}
.company-name {
  font-size: 28px;
  font-family: FZLanTingHeiS-DB1-GBK;
  font-weight: 400;
  color: #444444;
  width: 650px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.company-option {
  font-size: 14px;
  font-family: FZLanTingHeiS-DB1-GBK;
  font-weight: 400;
  color: #619a37;
}
.line {
  width: 1px;
  height: 16px;
  background: #dddddd;
  margin: 0 11px;
}
.company-option p {
  padding-left: 4px;
}
.company-detail-desc {
  max-width: 55%;
  p:first-child {
    width: 90%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}
.company-detail-desc p {
  font-size: 14px;
  font-family: FZLanTingHeiS-DB1-GBK;
  font-weight: 400;
  color: #666666;
  margin-top: 14px;
}
.company-detail {
  border-bottom: 1px solid #dddddd;
  padding-bottom: 11px;
}
.company-btnlist {
  flex-shrink: 0;
  p {
    font-size: 16px;
    font-family: FZLanTingHeiS-DB1-GBK;
    font-weight: 400;
    color: #999999;
    padding: 15px 55px;
    background: #ffffff;
    border: 1px solid #dddddd;
    cursor: pointer;
  }
}
.company-btnlist p:first-child {
  font-size: 16px;
  font-family: FZLanTingHeiS-DB1-GBK;
  font-weight: 400;
  color: #ffffff;
  background: #619a37;
  margin-right: 10px;
}
</style>



// WEBPACK FOOTER //
// src/view/productlist.vue